import { ArcElement, Chart, Legend, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import DateIcon from '../../../assets/svg/DateIcon';
import { REPORT_STATUS_MAP, STATUSES } from '../../../constants';
import { WidgetCard } from '../WidgetCard';
import { ChartLegend } from './ChartLegend';

Chart.register(ArcElement, Tooltip, Legend);

const getData = data => ({
  labels: [
    REPORT_STATUS_MAP.PERFORMED,
    REPORT_STATUS_MAP.SCHEDULED,
    REPORT_STATUS_MAP.DECLINED,
    REPORT_STATUS_MAP.NO_SHOW,
    REPORT_STATUS_MAP.REJECTED,
  ],
  datasets: [
    {
      data: [
        data.performed,
        data.scheduled,
        data.declined,
        data.noShow,
        data.rejected,
      ],
      backgroundColor: [
        'rgba(58, 179, 136, 1)',
        'rgba(96, 162, 227, 1)',
        'rgba(182, 7, 45, 1)',
        'rgba(240, 66, 66, 1)',
        'rgba(252, 142, 118, 1)',
      ],
      borderColor: 'rgb(255 255 255)',
      borderWidth: 2,
    },
  ],
});

const options = {
  animation: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  hover: {
    mode: null,
  },
};

export const ChartAppointmentOutcomes = ({ data }) => {
  return (
    <WidgetCard title="Appointment Outcomes" Icon={DateIcon}>
      <div className="flex items-center gap-8 h-[268px]">
        <div className="relative min-w-[182px] max-w-[202px] w-full aspect-square rounded-full shrink-0">
          <Doughnut data={getData(data.breakdown)} options={options} />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center gap-0.5">
            <span className="text-[14px]/[20px] text-base-800 font-medium">
              Total
            </span>
            <span className="max-w-[70px] truncate text-[22px]/[28px] text-base-1000 font-semibold">
              {data.total}
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-3 w-full">
          <ChartLegend
            color={STATUSES[0].color}
            label={STATUSES[0].label}
            valuePercent={data.breakdown['performed%']}
            value={data.breakdown.performed}
          />
          <ChartLegend
            color={STATUSES[1].color}
            label={STATUSES[1].label}
            valuePercent={data.breakdown['scheduled%']}
            value={data.breakdown.scheduled}
          />
          <ChartLegend
            color={STATUSES[2].color}
            label={STATUSES[2].label}
            valuePercent={data.breakdown['declined%']}
            value={data.breakdown.declined}
          />
          <ChartLegend
            color={STATUSES[3].color}
            label={STATUSES[3].label}
            valuePercent={data.breakdown['noShow%']}
            value={data.breakdown.noShow}
          />
          <ChartLegend
            color={STATUSES[4].color}
            label={STATUSES[4].label}
            valuePercent={data.breakdown['rejected%']}
            value={data.breakdown.rejected}
          />
        </div>
      </div>
    </WidgetCard>
  );
};
